var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-tooltip',{attrs:{"content":_setup.justCopied ? 'Copied' : 'Click to copy the email',"open-delay":250}},[_c('img',{staticClass:"clickable",attrs:{"src":require('@/assets/images/candidate-card/email.svg')},on:{"click":function($event){$event.stopPropagation();return _setup.copyTextToClipboard(_vm.email)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }